import React from 'react';
import { NewModal } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { useDeleteHighlightMutation } from 'lib/api/highlights/useDeleteHighlightMutation';
import { IHighlight } from 'lib/api/highlights/useQueryHighlights';
import { Trans, useTranslation } from 'react-i18next';

interface DeleteHighlightModalProps {
  highlight: IHighlight;
  onClose: () => void;
}

export const DeleteHighlightModal = ({
  highlight,
  onClose,
}: DeleteHighlightModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteHighlightMutation, isLoading: isDeleting } =
    useDeleteHighlightMutation(onClose);
  const onDelete = () => {
    deleteHighlightMutation({ id: highlight.highlightId });
  };

  return (
    <NewModal
      headerText={t('Delete Highlight')}
      closeModal={onClose}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Flex flexDirection='column' gap='20px'>
        <div>
          <Trans
            i18nKey='deleteHighlightConfirmation'
            values={{ title: highlight.title }}
          />
        </div>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text={t('Cancel')}
            onClick={onClose}
            variant='secondary'
            disabled={isDeleting}
          />
          <Button
            text={t('Delete')}
            onClick={onDelete}
            variant='destructive'
            loading={isDeleting}
            disabled={isDeleting}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};
